import GLScroll from './index.vue'

GLScroll.install = function (Vue) {
  Vue.component(GLScroll.name, GLScroll)
}

export default GLScroll
